import { Component, type ErrorInfo, type ReactNode } from "react";
import { Centered } from "./Centered";

/**
 * Top-level error boundary (spec §13): a render error anywhere in the tree shows
 * a friendly screen instead of a blank/broken page. Catches the unexpected —
 * e.g. a charting-library failure — that the per-store error states don't cover.
 */
type Props = { children: ReactNode };
type State = { hasError: boolean };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Surface for debugging; there is no server to report to.
    console.error("candlealpha crashed:", error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <Centered>Something went wrong. Please reload the page.</Centered>;
    }
    return this.props.children;
  }
}
